<template>
  <div>
    <!-- 页面加载图 -->
    <b-load :src="load_img_url" v-if="false"></b-load>

    <!-- 页面部分 -->
    <div class="main">
      <!-- 头部 -->
      <div class="title">
        <!-- 标题 -->
        <van-nav-bar
          v-show="!isShowSearch"
          :title="title"
          :fixed="true"
          :z-index="99"
          @click-left="onClickBack"
          @click-right="onClickMore" >
          <div class="icon-back" slot="left">
            <img src="../../../static/images/icon-back.png" alt="返回" />
          </div>
          <div class="icon-menu" slot="right">
            <img
              src="../../../static/images/fightGroups/icon_menu.png"
              alt="更多"
            />
          </div>
        </van-nav-bar>

        <!-- 搜索 -->
        <van-search
          v-show="isShowSearch"
          v-model="searchValue"
          placeholder="请输入搜索关键词"
          show-action
          shape="round"
          :clearable="true"
          @search="onSearch"
          @cancel="onSearchCancel" >
        </van-search>

        <!-- 菜单 -->
        <b-more-menu
          :show="isShowMenu"
          :search="true"
          :home="true"
          :reload="true"
          :center="true"
          :top="44"
          :right="11"
          @close="closeMenu"
          @search="searchShow"
        ></b-more-menu>
      </div>
      <!-- 导航栏 -->
      <van-tabs
        v-model="active"
        line-height="2px"
        line-width="26px"
        title-active-color="#FF2F2F"
        title-inactive-color="#222222"
        color="#FF2F2F"
        :sticky="true"
        :offset-top="50"
        :swipe-threshold="5"
        swipeable
        animated
      >
        <van-tab v-for="(tab, index) in tabs" :title="tab" :key="index">
          <div class="content">
            <!-- 拼团商品 -->
            <div id="list_wrap" ref="list_wrap">
              <div class="goods-list">
                <template v-for="item in 8">
                  <b-goods :item="item" :key="item"></b-goods>
                </template>
              </div>
            </div>

            <!-- 无数据 -->
            <div class="not-list" v-if="false">
              <img
                src="../../../static/images/fightGroups/icon_not_data.png"
                alt="暂无数据"
              />
              <p>还没有相关的活动</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import utils from "../../../static/js/b_utils.js";
import bLoad from "./components/Load";
import bMoreMenu from "./components/Menu";
import bGoods from "./components/Goods";
export default {
  name: "",
  data() {
    return {
      load_img_url: "../../../static/images/fightGroups/group_list_load.png", //加载默认图片
      title: "拼团商城",
      active: 0,
      tabs: [
        "全部",
        "手机壳 ",
        "贴膜",
        "手机存储卡",
        "数据线",
        "充电器",
        "手机耳机",
        "创意配件"
      ],
      isShowSearch: false,// 是否显示搜索框
      isShowMenu: false, // 是否显示更多菜单
      searchValue: '',// 搜索文字
    };
  },
  components: {
    bLoad,
    bGoods,
    bMoreMenu
  },
  mounted() {},
  methods: {
    // 头部返回
    onClickBack() {},
    // 更多菜单
    onClickMore() {
      this.isShowMenu = !this.isShowMenu;
    },
    // 关闭更多菜单
    closeMenu() {
      this.isShowMenu = false;
    },
    // 显示搜索框
    searchShow() {
      this.isShowSearch = true;
    },
    // 搜索
    onSearch() {
      console.log(this.searchValue)
    },
    // 取消搜索
    onSearchCancel() {
      this.isShowSearch = false;
    }
  }
};
</script>

<style scoped lang="scss">
// 头部
.title {
  .icon-back,
  .icon-menu {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .icon-back > img {
    display: block;
    width: 0.22rem;
    height: 0.37rem;
  }
  .icon-menu > img {
    display: block;
    width: 0.52rem;
    height: 0.1rem;
  }
}
.content {
  position: relative;
  margin-top: 0.1rem;
  .goods-list {
    margin-top: 55px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .not-list {
    position: absolute;
    left: 50%;
    top: 3.77rem;
    transform: translateX(-50%);
    background: #fff;
    height: calc(100vh - 100px);

    > img {
      display: block;
      margin: 0 auto;
      width: 2.11rem;
      height: 1.7rem;
    }
    > p {
      margin-top: 0.53rem;
      font-size: 0.24rem;
      color: #666666;
      text-align: center;
    }
  }
}
/deep/ .van-nav-bar.van-nav-bar--fixed.van-hairline--bottom {
  height: 50px;
  line-height: 50px;
}
/deep/ .van-tabs__line {
  bottom: 22px;
}
/deep/ .van-tabs__wrap.van-tabs__wrap--scrollable.van-hairline--top-bottom {
  border-radius: 0px 0px 12px 12px;
}
/deep/ .van-search.van-search--show-action {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 99;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/FightGroups/GroupList.vue